import { createAxiosInstance } from '@/apis/axios.utils';
import type { RequestPdfParams } from '@/apis/pdf.types';
import { env } from '@/env';
import type { AxiosRequestConfig } from '@/types/axios';

export type * from '@/apis/pdf.types';

export const axios = createAxiosInstance(env.pdfApiUrl);

export async function requestPdf(
  {
    url,
    filename,
    notificationSocketId,
    notificationMeta,
    width,
    height,
    format,
    landscape,
    scale,
    idleTimeout,
    idleMaxInflightRequest,
    useWaitFor,
    margin,
  }: RequestPdfParams,
  axiosConfig: AxiosRequestConfig = {},
) {
  return axios.post(
    `pdfs`,
    {
      url,
      filename,
      notificationSocketId,
      notificationMeta,
      width,
      height,
      format,
      landscape,
      scale,
      idleTimeout,
      idleMaxInflightRequest,
      useWaitFor,
      margin,
      delay: 15,
    },
    axiosConfig,
  );
}
